import ItemManager from "@/components/admin/ItemManager";

export default function BlogManager() {
  return (
    <ItemManager
      collection="posts"
      title="Blog & News"
      subtitle="Stories, press features and announcements. Drafts stay hidden from the website."
      testidPrefix="blog"
      fields={[
        { name: "title", label: "Headline", type: "text" },
        { name: "excerpt", label: "Short Summary", type: "textarea", rows: 2 },
        { name: "content", label: "Full Story (blank line between paragraphs)", type: "textarea", rows: 8 },
        { name: "image", label: "Cover Photo", type: "image" },
        { name: "published", label: "Visibility", type: "switch", default: true, hint: "Published on the website" },
      ]}
      cardTitle={(i) => i.title}
      cardSubtitle={(i) => i.excerpt}
    />
  );
}
